import { isBooleanOrUndefined } from "helpers/boolean";

import { ComponentTypeEnum } from "./component-types";

export interface ILinkComponentDefinition {
  type: ComponentTypeEnum.Link;
  data: {
    url: string;
    value?: string;
    inline?: boolean;
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isValidLinkDefinition(rawDefinitionData: any): boolean {
  if (!rawDefinitionData) {
    return false;
  }

  const { url, inline } = rawDefinitionData;
  return Boolean(url && isBooleanOrUndefined(inline));
}
